<template>
    <div class="flex-auto text-center flex min-h-0">
        <div class="flex flex-col flex-auto justify-center items-center min-h-0 -mt-20">
            <div class="mt-24 mx-10 mb-8">
                <div class="font-main font-medium text-21 text-a-blue-0056ff mb-2">
                    ได้รับข้อมูลของคุณแล้ว
                </div>
                <div class="text-16 font-main font-medium leading-normal">
                    สามารถตรวจสอบและดาวน์โหลด E-Care เก็บไว้
                    ได้ที่ <a class="text-a-orange-f36e21">Line ธนชาตประกันภัย</a> เมนูดาวน์โหลดกรมธรรม์
                </div>
            </div>
            <div>
                <img src="@/assets/register/TTB_ECare_Card_02@2x.png" class="mx-auto img-w-180" alt=""/>
            </div>
        </div>
    </div>
    <div class="flex-none">
        <div class="flex justify-end p-4">
            <img src="@/assets/logo/Logo-TMB.svg" alt="ttb" />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    setup: function () {
    },
})
</script>

<style lang="scss" scoped>
.img-w-180 {
    width: 180px;
}
</style>
